import React, { useEffect } from 'react';
import { useFormikContext } from 'formik';
import Text from 'components/Text';
import bem from 'utils/bem';
import PickUp from './PickUp';
import CDEK from './CDEK';

import './index.sass';

const { block, el } = bem('delivery-fields');

const DeliveryFields = ({ form, items, setDeliveryPrice, showWidget, setShowWidget, cdekLoadStatus }) => {

    const { setFieldValue, values: { delivery } } = useFormikContext();

    //todo: unnecessary?
    useEffect(() => {
        if (delivery === 'pickup_msk') {
            setDeliveryPrice(0);
        }
        if (delivery === 'cdek') {
            setShowWidget(true);
        }
    }, [delivery])

    useEffect(() => {
        setFieldValue('country', 'Российская Федерация');
        setFieldValue('region', '');
        setFieldValue('city', '');
        setFieldValue('index', '');
        setFieldValue('address', '');
        setDeliveryPrice(0);
    }, [form.values.delivery])

    return <div className={ block() }>
        <div className={ el('title') }>
            <Text serif>Тип доставки</Text>
        </div>
        <div className={ el('fields') }>
            <PickUp selected={delivery === 'pickup_msk'} />
            <CDEK form={ form } items={ items } setDeliveryPrice={ setDeliveryPrice } selected={delivery === 'cdek'}
                  showWidget={ showWidget } setShowWidget={ setShowWidget } cdekLoadStatus={cdekLoadStatus} />
        </div>
    </div>
}

export default DeliveryFields;
